export function assignObject<T extends object>(target: T, source: T): void {
  Object.assign(target, source);
}
